import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import toast from 'react-hot-toast';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const EconomicActivityFilters = ({ filters, search, onApply }) => {
  return (
    <div className="card">
      <div className="card-content">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div className="form-group">
            <label className="form-label">Nome</label>
            <input
              type="text"
              className="form-input"
              placeholder="Nome da atividade"
              value={filters.filters.name}
              onChange={(e) => filters.updateFilter('name', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Código CNAE</label>
            <input
              type="text"
              className="form-input"
              placeholder="0000-0/00"
              value={filters.filters.code}
              onChange={(e) => filters.updateFilter('code', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Tributação</label>
            <select
              className="form-select"
              value={filters.filters.isExempt}
              onChange={(e) => filters.updateFilter('isExempt', e.target.value)}
            >
              <option value="">Todas</option>
              <option value="true">Isento</option>
              <option value="false">Tributável</option>
            </select>
          </div>
          
          <div className="form-group">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={filters.filters.isActive}
              onChange={(e) => filters.updateFilter('isActive', e.target.value)}
            >
              <option value="">Todos os status</option>
              <option value="true">Ativo</option>
              <option value="false">Inativo</option>
            </select>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Can permission={P.CATALOG_ACCESS}>
              <button
                type="button"
                onClick={filters.clearFilters}
                className="btn btn-outline btn-sm"
              >
                <X className="w-4 h-4 mr-1" />
                Limpar
              </button>
            </Can>
            <Can permission={P.CATALOG_ACCESS}>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => {
                  if (onApply) onApply();
                  else toast.success('Filtros aplicados à lista.');
                }}
              >
                <Filter className="w-4 h-4 mr-1" />
                Filtrar
              </button>
            </Can>
          </div>
          
          <div className="flex items-center gap-2">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Buscar atividades..."
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                value={search.query}
                onChange={(e) => search.search(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EconomicActivityFilters;
